import { ReactElement, ReactNode, RefObject } from 'react';
import PullToRefreshComp from 'react-simple-pull-to-refresh';

import { isMobileBrowser } from '@labradorsports/utils';

import InlineLoadingSpinner from '../inline-loading-spinner/inline-loading-spinner.js';

export interface PanelProps {
    containerRef?: RefObject<HTMLDivElement>;
    className?: string;
    onRefresh?: AnyFunction;
    content: ReactNode;
    header?: ReactNode;
    footer?: ReactNode;
    isLoading?: boolean;
}

const Panel: FC<PanelProps> = ({
    containerRef,
    content,
    className = '',
    header,
    footer,
    onRefresh,
    isLoading,
    ...props
}) => {
    const classes = [];

    if (className) classes.push(className);
    if (footer) classes.push('has-footer');

    let panelContent = content;

    if (typeof onRefresh === 'function') {
        classes.push('pull-to-refresh');

        const pullToUpdate = <span className="pull-to-update">Pull to update</span>;

        panelContent = (
            <PullToRefreshComp
                isPullable={isMobileBrowser() && typeof onRefresh === 'function'}
                className={classes.join(' ')}
                refreshingContent={<div className="text-muted small mt-2">Updating...</div>}
                pullingContent={pullToUpdate}
                maxPullDownDistance={200}
                pullDownThreshold={150}
                onRefresh={async () => onRefresh()}
            >
                {content as ReactElement}
            </PullToRefreshComp>
        );
    }

    return (
        <div className={`panel-container ${classes.join(' ')}`} ref={containerRef} {...props}>
            <div className="panel-content">
                {header}
                {isLoading ? <InlineLoadingSpinner /> : panelContent}
            </div>
            <div className="panel-footer">{footer}</div>
        </div>
    );
};

export default Panel;
